export const CREATE_VENDOR_APPOINTMENT_REQUEST = 'CREATE_VENDOR_APPOINTMENT_REQUEST';
export const CREATE_VENDOR_APPOINTMENT_SUCCESS = 'CREATE_VENDOR_APPOINTMENT_SUCCESS';
export const CREATE_VENDOR_APPOINTMENT_FAILURE = 'CREATE_VENDOR_APPOINTMENT_FAILURE';

export const GET_VENDOR_APPOINTMENT_REQUEST = 'GET_VENDOR_APPOINTMENT_REQUEST';
export const GET_VENDOR_APPOINTMENT_SUCCESS = 'GET_VENDOR_APPOINTMENT_SUCCESS';
export const GET_VENDOR_APPOINTMENT_FAILURE = 'GET_VENDOR_APPOINTMENT_FAILURE';